import React, {useEffect, useState} from 'react';
import {PATS_NAMES_ROUTES} from '../../../configuration/index.config';
import { useHistory } from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import AiFactoryView from '../View/AiFactory.view';
import {storageService} from '../../../services/storageService';

const AiFactory = (props) => {
    const history = useHistory();
    const [isLoadAiFactory, setIsLoadAiFactory] = useState(false);

    useEffect(() => {
        const arrayRoutes = Object.keys(PATS_NAMES_ROUTES);
        const authenticationList = props.userStore.getAuthenticationList();
        const checkNumberOfRoutes:any = arrayRoutes.map((routes) => (authenticationList[routes] ? routes : null)).filter(Boolean);

        checkNumberOfRoutes.length === 1 ? history.push(`/${PATS_NAMES_ROUTES[checkNumberOfRoutes[0]]}`) : setIsLoadAiFactory(true);
        storageService.removeFromStorage('refresh');
    }, []);

    return <AiFactoryView {...props} isLoadAiFactory={isLoadAiFactory}/>;
};

export default inject('userStore')(observer(AiFactory));
